import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
    GET_SWING_LIST
} from "../constants/ActionTypes";
import {
    getSwingListSuccess,
    getSwingListError
} from "../actions/SwingAction";
import { userSignOut } from '../actions/Auth'
import { getSwingListApi } from "../api/SwingApi";

function* getSwingListRequest({ payload }) {
    try {
        const swingList = yield call(getSwingListApi, payload);
        if (swingList.code) {
            if (swingList.code === 401) {
                yield put(userSignOut());
            } else {
                yield put(getSwingListError(swingList));
            }
        } else {
            yield put(getSwingListSuccess(swingList));
        }
    } catch (error) {
        yield put(getSwingListError(error));
    }
}

export function* getSwingList() {
    yield takeEvery(GET_SWING_LIST, getSwingListRequest);
}

export default function* rootSaga() {
    yield all([fork(getSwingList)
    ]);
}